import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Categoria.types'
import { ICategoria } from './Categoria.lib';

export class Categoria extends ICategoria {

 

    public static Route = `/web/web/categorias`;
    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Categoria>; Error?: boolean; }>
    {

        let a: Array<Categoria> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/web/web/categorias` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new Categoria( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${Categoria.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
            else
            {
                req.path = `${Categoria.Route}`;
                console.log( req.path );
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
            
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${Categoria.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }
}